export * from './localStorage'


// WEBPACK FOOTER //
// ./src/store/services/storage/index.js